import { useEffect, useState } from "react";
/**
* Custom hook to manage the "Don't Show Onboarding Again" flag.
* Persists the flag in localStorage to remember user preference across sessions.
* 
* @returns {{
*   dontShow: boolean;       // Current flag indicating if onboarding should be skipped
*   setDontShow: (val: boolean) => void;  // Setter to update the flag
* }}
*/
export const useDontShowOnboarding = () => {
    // Dont show again flag
    const [dontShow, setDontShow] = useState<boolean>(() => {
        const saved = localStorage.getItem("dontShowAgainCatermat");
        return saved ? JSON.parse(saved) : false;
    })
    // Save to session storage on change
    useEffect(()=>{
        localStorage.setItem("dontShowAgainCatermat", JSON.stringify(dontShow))
    }, [dontShow])

    return {dontShow, setDontShow}
};